@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.User {
  @extend %font-family-primary;

  white-space: nowrap;
  font-size: $font-size-normal;
  color: $color-grey-B;
  display: inline-flex;
  align-items: center;
  line-height: 13px;
  height: 12px;
  vertical-align: middle;

  [aria-hidden='true'] {
    font-size: 8px;
    margin-right: 0.5em;
  }
}
